const offerTypes = [
  { value: "STAY", label: "Stay" },
  { value: "sightseeing_leisure", label: "Sightseeing + leisure" },
  { value: "sightseeing_tour", label: "Sightseeing tour" },
  { value: "city_break", label: "City Break" },
  { value: "colonies_camps", label: "Colonies/camps" },
  { value: "skis", label: "Skis" },
  { value: "cruise", label: "Cruise" },
  { value: "pilgrimages", label: "Pilgrimages" },
  { value: "language_courses", label: "Language courses" },
];

export default offerTypes;
